"use strict";

const PatientFormCtrl = function ($rootScope, $state, $q, $stateParams, PatientsService, Notification) {
    var ctrl = this,
    initModel = {
      gender: "MALE",
      center: $rootScope.user.center[0] ? $rootScope.user.center[0].uuid : '',
      diagnosisICD: Object.keys($rootScope.config.icdCodes)[0],
      plz: "00000",
      ort: "-",
      lostToFollowUp: false,
    };

    ctrl.gender = {
      "MALE": 'männlich',
      "FEMALE": 'weiblich'
    };
  
    ctrl.model = initModel;

    ctrl.$onInit = function() {
      PatientsService.getAll().then(function (data) {
        ctrl.patients = data.patients;
      });

      if ($stateParams.patient) {
        ctrl.model = $stateParams.patient;
        ctrl.model.geburtstag = $stateParams.patient.birthdate.getDate();
        ctrl.model.geburtsmonat = $stateParams.patient.birthdate.getMonth() + 1;
        ctrl.model.geburtsjahr = $stateParams.patient.birthdate.getFullYear();
        ctrl.model.center = $stateParams.patient.center.uuid;
        //ctrl.model.agreementDate = new Date($stateParams.patient.agreementDate);
      }
    };

    ctrl.add = function (form) {
      if (form.$valid) {
        ctrl.model.geburtsname = ctrl.model.geburtsname || ctrl.model.nachname;
        PatientsService.save(ctrl.model).then(function () {
          ctrl.model = initModel;
          $state.go('main.patients.list');
          Notification.success('Ein neuer Patient wurde angelegt.');          
        }, function(){
          Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
        });
      }
    };

    ctrl.updateBirthdate = function () {
      if (ctrl.model.birthdate) {
        ctrl.model.geburtstag = ctrl.model.birthdate.getDate();
        ctrl.model.geburtsmonat = ctrl.model.birthdate.getMonth() + 1;
        ctrl.model.geburtsjahr = ctrl.model.birthdate.getFullYear();
      }
    };

    ctrl.update = function (form) {
      if (form.$valid) {
        $q.all([
          PatientsService.updateIdat(ctrl.model),
          PatientsService.updateMdat(ctrl.model)
        ])
          .then(function () {
            Notification.success('Änderungen erfolgreich gespeichert.');
          }, function(){
            Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
          });
      }
    };

    ctrl.$doCheck = function(){
      // compare form data to existing patients
      if ($rootScope.user.hasPermission("00111")){
        ctrl.similarPatient = ctrl.testForSimilarPatientData(ctrl.patients, ctrl.model);
      }
    };

    ctrl.testForSimilarPatientData = function (data, comparable) {
      if(ctrl.model.uuid){
        // no create, just update
        return false;
      }
      if (data) {
        for (var patient in data){
          if (data.hasOwnProperty(patient)) {
            if (
              (data[patient].vorname === comparable.vorname) &&
              (data[patient].nachname === comparable.nachname) &&
              (data[patient].birthdate.getFullYear() === comparable.geburtsjahr) &&
              (data[patient].birthdate.getMonth() + 1 === comparable.geburtsmonat) &&
              (data[patient].birthdate.getDate() === comparable.geburtstag)
            ) {
              return data[patient].pid;
            }
          }
        }
      }
      return false;
    };
  };

PatientFormCtrl.$inject = ['$rootScope', '$state', '$q', '$stateParams', 'PatientsService', 'Notification'];

module.exports = {
  template: require('./patients-form.html'),
  controller: PatientFormCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/form-patient/form-patient.component.js